import { PurchaseOrderService } from "@common/client"
import { makeAxiosMutation, makeQuery } from "./utils"

export const purchaseOrdersBaseKey = ["purchase-orders"] as const

export const purchaseOrdersKey = (
  params: Parameters<typeof PurchaseOrderService.listPurchaseOrders>[0],
) => [...purchaseOrdersBaseKey, "list", params] as const

export const purchaseOrderKey = (
  params: Parameters<typeof PurchaseOrderService.getPurchaseOrder>[0],
) => [...purchaseOrdersBaseKey, "detail", params] as const

export const purchaseOrdersQuery = makeQuery({
  serviceCall: PurchaseOrderService.listPurchaseOrders,
  queryKey: purchaseOrdersKey,
})

export const purchaseOrderQuery = makeQuery({
  serviceCall: PurchaseOrderService.getPurchaseOrder,
  queryKey: purchaseOrderKey,
})

export const useCreatePurchaseOrderMutation = makeAxiosMutation({
  serviceCall: PurchaseOrderService.createPurchaseOrder,
  invalidates: () => [purchaseOrdersBaseKey],
})

export const useExportPurchaseOrderPdfMutation = makeAxiosMutation({
  serviceCall: PurchaseOrderService.exportPurchaseOrderPdf,
  invalidates: () => [],
})
